import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { UNLOGGED } from "util/constants";
import { trackAnonymousAuthRedirectBlocked } from "util/anonymousAnalytics";
import { buildLoginRedirectPath, isPublicAppPath } from "util/routeAccess";

/**
 * Blocks protected routes for logged-out users. Must live inside <Router> so
 * useLocation() updates after Redirect and the login route can render.
 */
const AuthRouteGuard = ({ authenticated, children }) => {
  const location = useLocation();
  const blocked =
    authenticated === UNLOGGED && !isPublicAppPath(location.pathname);

  useEffect(() => {
    if (!blocked) return;
    trackAnonymousAuthRedirectBlocked(location.pathname, location.search);
  }, [blocked, location.pathname, location.search]);

  if (blocked) {
    const returnPath = `${location.pathname}${location.search}`;
    return <Redirect to={buildLoginRedirectPath(returnPath)} />;
  }

  return children;
};

export default AuthRouteGuard;
